import React, { Fragment } from 'react';
import { Routes, Route } from 'react-router';
import { Outlet } from '@usas/ui-web/wrappers/ReactRouterDom';

import Team from './views/team/Team';

import PageNotFound from '@usas/ui-web/components/PageNotFound';
import UnexpectedError from '@usas/ui-web/components/UnexpectedError';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';
import ErrorBoundary from '@usas/ui-web/components/errors/ErrorBoundary';
import ErrorBoundaryFallback from '@usas/ui-web/components/errors/ErrorBoundaryFallback';

const AppRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <Routes>
        <Route path={navRoutes['HOME']?.path} element={<Fragment><Outlet /></Fragment>}>
          <Route path={navRoutes['TEAM_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['TEAM_ROOT']}
                editElement={<Team />} />
            }
          />

          <Route path="500" element={<UnexpectedError />} />
          <Route path="/*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}

export default AppRoutes;